// extracted by mini-css-extract-plugin
export var divider = "_r6-0";
export var systemMessage = "_r6-1";